import PropTypes from 'prop-types';
import { Routes } from 'react-router-dom';
import React, { PureComponent } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { routeWithSubRoutes } from '@client/shared/utils/routerUtils/routerUtils';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import SideBarMenu from '@client/containers/sideBarMenu/SideBarMenu';
import {
  loadProfilePageData,
  selectProfilePageData,
} from '@client/pages/profilePage/duckProfilePage';
import styles from './profilePage.scss';

class ProfilePage extends PureComponent {
  static loadData(dispatch) {
    return dispatch(loadProfilePageData());
  }

  componentDidMount() {
    ProfilePage.loadData(this.props.dispatch);
  }

  render() {
    const { routes, location } = this.props;

    return (
      <div className={`${styles.profilePage} ${styleHelper.contentContainer}`}>
        <div className={styles.asideContainer}>
          <SideBarMenu pathname={location.pathname} />
        </div>
        <div className={styles.mainContainer}>
          <Routes>
            {routes &&
              routes.map((route, index) => routeWithSubRoutes(route, index))}
          </Routes>
        </div>
      </div>
    );
  }
}

ProfilePage.propTypes = {
  dispatch: PropTypes.func,
  routes: PropTypes.array,
  location: PropTypes.object,
  pageData: ImmutablePropTypes.map,
};

function mapStateToProps(state) {
  return {
    pageData: selectProfilePageData(state),
  };
}
export default connect(mapStateToProps)(ProfilePage);
